import React, { useEffect, useRef, useState } from "react";
import { TiArrowLeftThick, TiArrowRightThick } from "react-icons/ti";
import leaf from "../../Asset/subsribtion/leaf.png";
import Card from "./component/Card";
import bg from "../../Asset/subsribtion/bg.jpg";
import AOS from "aos";
import "aos/dist/aos.css";
import categoryModel from "../../model/category.model";

const Subscribe = () => {
  const scrollRef = useRef(null);
  const startXRef = useRef(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [data, setData] = useState([]);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const { scrollLeft, clientWidth } = scrollRef.current;
      const scrollAmount = clientWidth / 2;

      scrollRef.current.scrollTo({
        left:
          direction === "left"
            ? scrollLeft - scrollAmount
            : scrollLeft + scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const handleSmallScreenScroll = (direction) => {
    if (direction === "left" && currentIndex > 0) {
      setCurrentIndex((prev) => prev - 1);
    } else if (direction === "right" && currentIndex < data.length - 1) {
      setCurrentIndex((prev) => prev + 1);
    }
  };

  useEffect(() => {
    AOS.init();
    fetchCategory();
  }, []);

  const fetchCategory = async () => {
    try {
      const response = await categoryModel.GetList("subscription");
      setData(response?.data?.data || []);
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <div
      className="w-full bg-Background5 xl:pb-32 2xl:pb-48 relative z-0"
      data-aos="zoom-out-right"
    >
      <div className="py-7 md:px-12 px-4">
        {/* Header Section */}
        <div className="flex justify-between">
          <div className="flex gap-6">
            <div className="h-[55px] sm:h-full">
              <img src={leaf} alt="leaf" className="h-full" />
            </div>
            <div className="flex flex-col">
              <span className="text-textColor text-lg md:text-4xl font-bold title">
                Subscribe Now
              </span>
              <span className="text-textColor text-base md:text-xl">
                Subscribe for hassle free experience
              </span>
            </div>
          </div>

          {/* Navigation Arrows */}
          <div className="hidden sm:flex gap-4 sm:gap-6 text-3xl text-textColor">
            <div
              className="bg-textColor text-Background1 w-10 h-10 sm:w-11 sm:h-11 flex justify-center items-center rounded-full cursor-pointer"
              onClick={() => {
                handleSmallScreenScroll("left");
                scroll("left");
              }}
            >
              <TiArrowLeftThick />
            </div>
            <div
              className="bg-textColor text-Background1 w-10 h-10 sm:w-11 sm:h-11 flex justify-center items-center rounded-full cursor-pointer"
              onClick={() => {
                handleSmallScreenScroll("right");
                scroll("right");
              }}
            >
              <TiArrowRightThick />
            </div>
          </div>
        </div>


        {/* Card Display Section */}
        <div className="mt-5 overflow-hidden relative">
          {/* Desktop View - Horizontal Scroll */}
     <div
            ref={scrollRef}
            className={`hidden ${data?.length > 8 ? 'grid-rows-2 grid-flow-col' : ''}  
             gap-16 overflow-x-hidden scrollbar-hide scroll-smooth pb-10 pt-3 z-1
              ${data?.length <= 8 ? "md:flex md:flex-row " : ""}`}
          >
            {data?.map((item, index) => (
              <div key={index} className="min-w-[200px] max-w-[350px]">
                <Card item={item} />
              </div>
            ))}
          </div>

          {/* Mobile View - Swipeable Single Card */}
          <div
            className="md:hidden w-full flex justify-center items-center transition-transform duration-300 py-8"
            onTouchStart={(e) => (startXRef.current = e.touches[0].clientX)}
            onTouchEnd={(e) => {
              const endX = e.changedTouches[0].clientX;
              const diff = startXRef.current - endX;
              if (diff > 50) handleSmallScreenScroll("right");
              else if (diff < -50) handleSmallScreenScroll("left");
            }}
          >
            {data && data.length > 0 ? (
              <Card item={data[currentIndex]} />
            ) : (
              <p>No Data Available</p>
            )}
          </div>
        </div>
      </div>

      {/* Background Image */}
      <div className="w-full absolute bottom-0 -z-[1]">
        <img src={bg} className="w-full object-cover" alt="background" />
      </div>
    </div>
  );
};

export default Subscribe;